<template>
  <div class="podcast-section-export">
    <div class="text-gray-600" v-if="publishing">
      Pubblicazione in corso...
    </div>
    <div class="text-gray-600" v-else-if="publishingError">
      {{ publishingError }}
    </div>
    <div class="loaded_podcast" v-else>
      <div class="grid grid-flow-col grid-cols-2 grid-rows-1 gap-4">
        <div
          style="min-height: 360px;"
          class="bg-white border-t border-b sm:border shadow"
        >
          <div>
            <div class="text-left px-6 py-4">
              <div class="py-2">
                <h3 class="text-blue-dark py-6 font-normal text-xl">
                  Scarica il file .zip
                </h3>
                <div class="text-2xl text-grey-darker font-medium mb-4">
                  Il file ZIP contiene il tuo podcast.
                </div>
                <div class="text-grey max-w-sm mb-6">
                  Lo potrai pubblicare direttamente nel tuo sito per renderlo
                  visibile a tutti!
                </div>
                <div class="pt-5 pb-4">
                  <a :href="exportUrl" type="button" class="btn-secondary">
                    Download Zip
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="bg-white border-t border-b sm:border shadow"
          style="min-height: 360px;"
        >
          <div>
            <div class="text-left px-6 py-4">
              <div class="py-2">
                <h3 class="text-blue-dark py-6 font-normal text-xl">
                  Pubblica online
                </h3>
                <div class="mb-1">
                  Il tuo visual podcast è visibile a questo link:
                </div>
                <a
                  :href="shareUrl"
                  target="_blank"
                  rel="noopener"
                  class="inline text-black font-bold pt-2 pb-3"
                  >{{ shareUrl }}</a
                >
                <button
                  :class="styleCopy"
                  class="text-gray-600 pb-6 inline-block ml-2 -pt-2"
                  @click="copyToClipboard"
                >
                  <CopyIcon />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

import PodcastSectionBase from './PodcastSectionBase'
import CopyIcon from '@/assets/icons/copy.svg'

import GET_FOLDER_DATA from '@/graphql/GetFolderData.gql'

export default {
  extends: PodcastSectionBase,
  components: {
    CopyIcon,
  },
  section: {
    query: null,
  },

  data() {
    return {
      publishing: true,
      publishingError: '',
      styleCopy: 'text-gray-600 pb-6',
    }
  },

  computed: {
    exportUrl() {
      return `/.netlify/functions/podcast-export-zip?tenant=${this.$route.params.tenant}&podcast=${this.id}&token=${this.$store.state.user.profile.token}&preview=0`
    },
    shareUrl() {
      const podcast = this.id
      const tenant = this.$route.params.tenant
      const protocol = location.protocol
      const slashes = protocol.concat('//')
      const host = slashes.concat(window.location.hostname)
      const port = ':' + location.port !== ':' ? ':' + location.port : ''

      return `${host}${port}/share?t=${tenant}&p=${podcast}`
    },
  },

  created() {
    axios
      .get('/.netlify/functions/podcast-json-save', {
        params: {
          podcast: this.id,
          token: this.$store.state.user.profile.token,
          tenant: this.$route.params.tenant,
        },
      })
      .then(() => {
        this.publishing = false

        if (this.$store.state.podcast.currentPodcast) {
          const query = {
            query: GET_FOLDER_DATA,
            variables: {
              id: this.$store.state.podcast.currentPodcast.folder._id,
            },
          }

          let data
          try {
            data = this.$apolloProvider.defaultClient.cache.readQuery(query)
          } catch {
            // do nothing
          }

          if (data && data.findFolderByID) {
            const podcast = data.findFolderByID.podcasts.data.find(
              podcast => podcast._id === this.id,
            )

            if (podcast) {
              podcast.publishedAt = Date.now() * 1000
            }

            this.$apolloProvider.defaultClient.cache.writeQuery({
              ...query,
              data,
            })
          }
        }
      })
      .catch(() => {
        this.publishingError =
          'Non è stato possibile pubblicare la Story. Riprovare più tardi.'
        this.publishing = false
      })
  },
  methods: {
    copyToClipboard(event) {
      event.preventDefault()

      this.styleCopy = 'text-gray-600 pb-6 animate-zoom_in_out'

      const el = document.createElement('textarea')
      el.value = this.shareUrl
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      setTimeout(() => {
        this.styleCopy = 'text-gray-600 pb-6'
      }, 1000)
    },
  },
}
</script>

<style lang="scss" scoped></style>
